// extracted by mini-css-extract-plugin
export default {"img":"Login_img__Damun","formSide":"Login_formSide__DEDsz","loginForm":"Login_loginForm__hLk8z","loginFlex":"Login_loginFlex__lD9ih","form":"Login_form__pO4V9"};